import { toast } from '@/components/ui/toast';

export const createPhpSession = async (token: string) => {

    try {
        const response = await fetch('/app/components/auth/login/index.php', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `loginJWT=${token}`
        });

        if (!response.ok) {
            toast.error('Failed to create session');
            return false;
        }

        const data = await response.json();
    
        return data.success?.path ? true : false;

        toast.error(data.error?.message || 'Session creation failed');
    } catch (error) {
        toast.error('Session creation failed');
        return false;
    }
};